/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { actions as userActions } from '@@services/userservice';
import { LoadingState, LoadingProgress } from '@inwink/loadable';
import { connectwith } from '@inwink/react-utils/decorators/connectwith';
import { OidcView } from '@inwink/oidcview';
import { States } from '@@services/services';
import { InwinkLoader } from './ui/inwinkloader';
import { AppTextLabel, I18NResourcesContext } from '@@services/i18nservice';
import { craftAssetUrl } from '@@services/assetservice';

import './appshell.authentication.less';

interface IAuthenticationProps {
    // event: States.IEventState;
    userActions?: typeof userActions;
    i18n: States.i18nState;
}

interface IAuthenticationState {
    userchecked: boolean;
    progress: { message: string };
}

const apptradspatch = require("../trads/app.json");

@connectwith(null, (dispatch) => ({ userActions: bindActionCreators(userActions, dispatch) }))
export class Authentication extends React.Component<IAuthenticationProps, IAuthenticationState> {
    unmounted: boolean;

    constructor(props: IAuthenticationProps) {
        super(props);
        this.state = {
            userchecked: false,
            progress: {
                message: "appinit.checkauthentication"
            }
        };
    }

    authenticated = () => {
        return this.props.userActions.checkCurrentUser();
    };

    failed = () => {
        return;
    };

    componentDidMount() {
        const action = this.props.userActions.checkCurrentUser() as any as Promise<any>;
        action.then(null, (err) => {
            console.warn(err);
        }).then(() => {
            if (!this.unmounted) {
                this.setState({ userchecked: true, progress: { message: "" } });
            }
        });
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    renderLoader(data) {
        return <InwinkLoader message={data.message} />;
    }

    renderLogin = (p) => {
        return <div className="oidcview">
            <div className="panel notconnected">
                <img src={craftAssetUrl("/assets/inwink/LOGO_RGB.svg")} />
                <h3>
                    <AppTextLabel i18n="user.notconnected.title" />
                </h3>
                <p className="description">
                    <AppTextLabel i18n="user.notconnected.desc" />
                </p>
                <div className="actions">
                    {p.isChecking ? <AppTextLabel i18n="user.notconnected.logging" /> : <button onClick={(arg) => {
                        arg.preventDefault();
                        if (inwink.config.clientConfig.authMode === 'cookies') {
                            console.log('try login', p);
                            location.href = inwink.config.authUrl + '?redirecturi=' + encodeURIComponent(location.href);
                            return;
                        }
                        p.signin();
                    }}>
                        <AppTextLabel i18n="user.notconnected.popup" />
                    </button>}
                </div>
                <p>
                    <AppTextLabel i18n="user.notconnected.noaccount" />&nbsp;
                    <a href="https://www.inwink.com?utm_source=backoffice" target="_blank">
                        <AppTextLabel i18n="user.notconnected.discoverinwink" />
                    </a>
                </p>
            </div>
        </div>;
    };

    render() {
        const rooturl = location.href;
        if (this.state.userchecked === true) {
            return <I18NResourcesContext resources={apptradspatch}>
                <LoadingState isLoading={!this.state.userchecked}>
                    <OidcView
                        // eventid={this.props.event ? this.props.event.eventid : undefined}
                        rooturl={rooturl}
                        component={this.renderLogin}
                        onLoading={this.renderLoader}
                        onAuthentication={this.authenticated}
                        onAuthenticationFailed={this.failed}
                        displayLanguageCode={this.props.i18n.currentLanguageCode} />
                </LoadingState>
            </I18NResourcesContext>;
        }

        return <I18NResourcesContext resources={apptradspatch}>
            <LoadingState isLoading={!this.state.userchecked}>
                <LoadingProgress progress={this.state.progress}>
                    <div className="oidcview">
                        <div className="panel loading"><InwinkLoader className="big" display="bubbles" /></div>
                    </div>
                </LoadingProgress>
            </LoadingState>
        </I18NResourcesContext>;
    }
}
